'use strict';
(() => {
  const dialog = document.querySelector('[data-gallery-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const image = dialog.querySelector('[data-gallery-image]');
  const title = dialog.querySelector('[data-gallery-title]');
  const label = dialog.querySelector('[data-gallery-label]');
  const count = dialog.querySelector('[data-gallery-count]');
  const previous = dialog.querySelector('[data-gallery-previous]');
  const next = dialog.querySelector('[data-gallery-next]');
  const request = dialog.querySelector('[data-gallery-request]');
  const imageError = dialog.querySelector('[data-gallery-error]');
  const original = dialog.querySelector('[data-gallery-original]');
  const historyKey = 'jmoGallery';
  const sessions = new Map();
  const automaticPieces = new WeakMap();
  let active = null;
  let pendingNavigation = null;
  let waitingForBack = false;

  function followRequest() {
    if (!pendingNavigation) return;
    const destination = new URL(pendingNavigation, location.href);
    pendingNavigation = null;
    const form = document.querySelector('#design-request');
    const input = form?.querySelector('[data-piece-request]');
    const current = new URL(location.href);
    if (input && destination.origin === current.origin && destination.pathname === current.pathname && destination.searchParams.get('view') === current.searchParams.get('view')) {
      if (input.dataset.inquiryEdited !== 'true' && (!input.value || input.value === automaticPieces.get(input))) {
        input.value = (destination.searchParams.get('piece') || '').slice(0, 200);
        automaticPieces.set(input, input.value);
      }
      form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      input.focus({ preventScroll: true });
      return;
    }
    location.assign(destination.href);
  }

  function initializeLinks() {
    document.querySelectorAll('[data-jmo-gallery] [data-gallery-open]').forEach(link => {
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', dialog.id);
    });
  }

  function render(index) {
    if (!active) return;
    active.index = (index + active.links.length) % active.links.length;
    const link = active.links[active.index];
    const thumbnail = link.querySelector('img[alt]:not([alt=""])');
    imageError.hidden = true;
    image.hidden = false;
    image.alt = thumbnail?.alt || link.dataset.galleryTitle || '';
    image.src = link.href;
    title.textContent = link.dataset.galleryTitle || thumbnail?.alt || '';
    label.textContent = link.dataset.galleryLabel || '';
    label.hidden = !label.textContent;
    request.href = link.dataset.galleryRequest;
    original.href = link.href;
    count.textContent = dialog.dataset.galleryCountTemplate
      .replace('[current]', String(active.index + 1))
      .replace('[total]', String(active.links.length));
    previous.disabled = active.links.length < 2;
    next.disabled = active.links.length < 2;
  }

  function show(session, pushHistory) {
    if (!session.opener.isConnected) return false;
    active = session;
    render(session.index);
    try { dialog.showModal(); } catch { active = null; return false; }
    document.documentElement.classList.add('jmo-gallery-is-open');
    if (pushHistory) {
      try {
        history.pushState({ ...history.state, [historyKey]: session.token }, '', location.href);
        session.hasHistory = true;
        sessions.set(session.token, session);
      } catch { session.hasHistory = false; }
    }
    return true;
  }

  function dismiss(useHistory = true) {
    if (!active) return;
    const session = active;
    active = null;
    dialog.close();
    document.documentElement.classList.remove('jmo-gallery-is-open');
    if (session.opener.isConnected) session.opener.focus({ preventScroll: true });
    if (useHistory && session.hasHistory && history.state?.[historyKey] === session.token) {
      waitingForBack = true;
      history.back();
    } else followRequest();
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const opener = event.target.closest('[data-gallery-open]');
    const gallery = opener?.closest('[data-jmo-gallery]');
    if (!gallery) return;
    if (active || pendingNavigation || waitingForBack) { event.preventDefault(); return; }
    const links = [...gallery.querySelectorAll('[data-gallery-open]')];
    const session = { links, opener, index: links.indexOf(opener), token: `gallery-${Date.now()}-${Math.random().toString(36).slice(2)}`, hasHistory: false };
    if (show(session, true)) event.preventDefault();
  });

  dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dismiss());
  previous.addEventListener('click', () => render(active.index - 1));
  next.addEventListener('click', () => render(active.index + 1));
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('close', () => { if (active && !dialog.open) dismiss(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
  });
  dialog.addEventListener('keydown', event => {
    if (!active || event.altKey || event.ctrlKey || event.metaKey) return;
    if (event.key === 'Tab') {
      const controls = [...dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')]
        .filter(control => !control.disabled && control.tabIndex >= 0 && !control.closest('[hidden],[inert]') && control.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
      return;
    }
    if (event.target.closest('input,textarea,select,[contenteditable]')) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      render(active.index + (event.key === 'ArrowLeft' ? -1 : 1));
    }
  });
  request.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (!active) return;
    pendingNavigation = request.href;
    dismiss();
  });
  image.addEventListener('error', () => { image.hidden = true; imageError.hidden = false; });
  window.addEventListener('popstate', event => {
    waitingForBack = false;
    const token = event.state?.[historyKey];
    if (active && active.token !== token) dismiss(false);
    if (pendingNavigation) {
      followRequest();
      return;
    }
    if (!active && token && sessions.has(token)) show(sessions.get(token), false);
  });
  window.addEventListener('pagehide', () => { pendingNavigation = null; waitingForBack = false; });
  document.addEventListener('shopify:section:load', initializeLinks);
  document.addEventListener('shopify:section:unload', () => { if (active) dismiss(); });
  initializeLinks();
})();
